import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { api } from "../lib/api";
import Layout from "../components/Layout";
import { FileText, Upload, ChevronRight, CheckCircle2 } from "lucide-react";

export default function VendorPortal() {
  const [subRfqs, setSubRfqs] = useState([]);
  const [loading, setLoading] = useState(true);
  const navigate = useNavigate();

  useEffect(() => {
    (async () => {
      try {
        const { data } = await api.get("/vendor/sub-rfqs");
        setSubRfqs(data);
      } finally { setLoading(false); }
    })();
  }, []);

  return (
    <Layout>
      <div className="max-w-2xl mx-auto" data-testid="vendor-portal">
        <div className="font-mono-data text-[10px] tracking-[0.3em] uppercase text-amber-500 mb-2">Vendor Portal</div>
        <h1 className="font-display text-4xl mb-2">Open Sub-RFQs</h1>
        <p className="text-text-secondary mb-8">Tap a bid to upload your quote and HSE certifications.</p>

        {loading ? (
          <div className="text-center py-10 font-mono-data text-xs text-text-secondary animate-pulse">Loading bids...</div>
        ) : subRfqs.length === 0 ? (
          <div className="tray-inset p-10 text-center">
            <FileText className="w-10 h-10 text-text-secondary/40 mx-auto mb-3" />
            <div className="font-display text-xl">No open bids</div>
            <div className="text-text-secondary text-sm mt-2">Check back soon — subcontractors are uploading RFPs.</div>
          </div>
        ) : (
          <div className="space-y-3">
            {subRfqs.map(sr => (
              <button
                key={sr.id}
                onClick={() => navigate(`/vendor/quote/${sr.id}`)}
                data-testid={`vendor-srfq-${sr.id}`}
                className="tray w-full p-5 text-left flex items-center justify-between gap-4 hover:ring-2 hover:ring-amber-500/30 transition"
              >
                <div className="flex-1 min-w-0">
                  <div className="flex items-center gap-2 mb-1">
                    <span className="font-mono-data text-[10px] tracking-widest uppercase text-amber-500">{sr.category}</span>
                    {sr.my_quote && <CheckCircle2 className="w-3.5 h-3.5 text-emerald-400" />}
                  </div>
                  <div className="font-display text-lg truncate">{sr.rfp_title}</div>
                  <div className="font-mono-data text-xs text-text-secondary truncate">
                    {sr.operator} · {sr.line_items?.length} items · Due {sr.deadline}
                  </div>
                </div>
                <ChevronRight className="w-5 h-5 text-text-secondary" />
              </button>
            ))}
          </div>
        )}

        <button
          onClick={() => navigate(subRfqs[0] ? `/vendor/quote/${subRfqs[0].id}` : "/vendor")}
          data-testid="vendor-fab"
          className="fixed bottom-24 right-6 btn-tactile btn-amber rounded-full w-16 h-16 inline-flex items-center justify-center shadow-2xl z-40"
          title="Upload Quote"
        >
          <Upload className="w-6 h-6" />
        </button>
      </div>
    </Layout>
  );
}
